import React, { FC } from 'react';
import { useGetStories } from '@/queries/baseInfo';
import changelogs from '@/root/changelogs';
import { Icon } from '@/components/atomic/Icon';
import Button from '@/components/Button';
import { useGetRouteStoryData } from '@/components/Hint';
import { HintThumbNails } from '@/components/Hint/components/HintThumbnail';
import { useBreakPointDown } from '@/hooks/breakPoint';

const MAX_COUNT: number = 5;

export interface IBottomSheetContentProps {
  onClose: () => void;
}

const BottomSheetContent: FC<IBottomSheetContentProps> = ({ onClose }) => {
  const { labels } = useGetRouteStoryData(true);

  const { data, isLoading } = useGetStories({
    page: labels,
  });

  const isMdDown = useBreakPointDown('md');

  return (
    <>
      <div className="flex min-h-[calc(100%-76px)] flex-col gap-y-3 overflow-hidden">
        {isMdDown && (
          <HintThumbNails
            isChangelog={true}
            isLoading={isLoading}
            items={data || []}
          />
        )}
        {Object.keys(changelogs)
          .reverse()
          .slice(0, MAX_COUNT)
          .map((version, index) => (
            <div key={version}>
              <div className="mb-[9px] text-sm font-demibold text-blue-50">
                {index === 0 ? (
                  <>
                    اپلیکیشن مفید به نسخه &lrm;{version} بروزرسانی شد!
                    <br />
                    تغییرات نسخه فعلی:
                  </>
                ) : (
                  <>تغییرات نسخه &lrm;{version}</>
                )}
              </div>
              <ul className="flex list-inside list-none flex-col gap-y-[8px]">
                {changelogs[version].map((item, index) => (
                  <li
                    key={index}
                    className="flex items-start justify-start text-sm font-regular text-green-30"
                  >
                    <Icon
                      className="ml-2 mr-1 mt-[6px] flex-shrink-0"
                      icon="chevron_left"
                    />
                    <span className="text-gray-100">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
      </div>

      <div className="!sticky bottom-0 flex h-auto w-full items-center bg-[#fff] pb-5 pt-2">
        <Button
          analytics={['CHANGELOG']}
          id="home_submit_changelog"
          isFullWidth
          onClick={onClose}
        >
          متوجه شدم
        </Button>
      </div>
    </>
  );
};

export default BottomSheetContent;
